module.exports = __webpack_public_path__ + "img/aliMail.512aed43.png";